module.exports = __webpack_public_path__ + "static/media/changeMind.e8eac841.mp3";